module.exports = __webpack_public_path__ + "static/wr-catcher-vid-eba99ae4c455b42e666420bd4cbe28ab.mp4";